<template>
  <div class="block">
    <div class="container">
      <div class="title title-cust">合同管理创造管理价值</div>
      <div class="entitle entitle-cust">
        Contract management creates management value
      </div>

      <div class="row wrap-card">
        <div class="col-md-6">
          <div class="card">
            <img :src="p12" class="img-circle" alt="" />
            <div class="card-right">
              <div class="card-title">经办人视角</div>
              <div class="card-text">作业规范、签约更快、工作更方便</div>
            </div>
            <div class="hover">
              <div class="hover-wrap">
                <p>
                  1、规范、简化合同的管理流程，实现合同管理流程的闭环端到端，提升工作效率；
                </p>
                <p>
                  2、经办人、签约方、法务、审批者线上协作，条款谈判与修改，痕迹可追溯，过程更高效；
                </p>
                <p>
                  3、合同台账、合同视图，完整的合同信息汇总与推送，信息获取更简单，更全面，工作更方便；
                </p>
                <p>4、多维度合同风险控制，降低经办人合同签订与履约风险。</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card">
            <img :src="p13" class="img-circle" alt="" />
            <div class="card-right">
              <div class="card-title">财务视角</div>
              <div class="card-text">业财数据融合，助力财务催收与审核</div>
            </div>
            <div class="hover">
              <div class="hover-wrap">
                <p>
                  1、对合同的已付、未付、在途付、保证金等财务数据进行自动统计，方便财务工作；
                </p>
                <p>
                  2、打通履约中的进度、收货、开票、收付款、变更、扣款、罚款等数据，数据关联与穿透，助力财务付款审核；
                </p>
                <p>
                  3、汇总订单、项目等进度信息，推算应收数据，助力财务线上催收；
                </p>
                <p>
                  4、合同履约跟踪与数据汇总，业财融合，助力财务做好业财数据分析，应收、应付预测与管理。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card">
            <img :src="p14" class="img-circle" alt="" />
            <div class="card-right">
              <div class="card-title">法务视角</div>
              <div class="card-text">
                提升合同标准化、降低审核工作量、 风险更可控
              </div>
            </div>
            <div class="hover">
              <div class="hover-wrap">
                <p>
                  1、落实法务在合同管理制度与管理上的要求，实现合同的数字化管控；
                </p>
                <p>
                  2、规范合同范本的管理、更新、分发、版本及范本的使用，实现合同范本强管控；
                </p>
                <p>
                  3、提升合同的范本的标准化率，以及范本使用的覆盖率，大大降低法务审核工作量；
                </p>
                <p>
                  4、线上作业，修改比对，用印闭环，履约监控，资质推送，等众多辅助工具帮助法务工作提效同时降低合同潜在风险。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card">
            <img :src="p15" class="img-circle" alt="" />
            <div class="card-right">
              <div class="card-title">管理者视角</div>
              <div class="card-text">
                合同一键查、过程可追踪、数据更 全面、提效又降本，管理更简单
              </div>
            </div>
            <div class="hover">
              <div class="hover-wrap">
                <p>
                  1、统一企业所有系统内记录的以及线下走的合同形成电子化，规避了大公司部门管理合同的弊端；
                </p>
                <p>
                  2、记录合同从草拟、审核、用印到变更、付款等合同生命周期中的每一个环节与操作，构建合同的生命周期档案；
                </p>
                <p>
                  3、以合同为主体打通合同的相关订单、进度、质量等业务数据，实现数据贯穿，和全视图的汇总展示；
                </p>
                <p>
                  4、优化企业合同管理流程，实现管控闭环，流程提效的同时降低了管理中的风险。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import p12 from "@/assets/images/home/p12.png";
import p13 from "@/assets/images/home/p13.png";
import p14 from "@/assets/images/home/p14.png";
import p15 from "@/assets/images/home/p15.png";
export default {
  data() {
    return {
      p12,
      p13,
      p14,
      p15,
    };
  },
  mounted() {
    let that = this;
    window.$(".card").hover(
      function () {
        if (that.isMobile) {
          return;
        }
        window.$(this).children(".hover").fadeIn();
      },
      function () {
        window.$(this).children(".hover").fadeOut();
      }
    );
  },
};
</script>

<style scoped>
.title-cust {
  color: #3975ea;
}
.entitle-cust {
  color: #b3b3b3;
}
.wrap-card {
  margin-top: 60px;
}
.card {
  padding: 20px;
  height: 200px;
  margin-bottom: 20px;
  background: #ffffff;
  box-shadow: 4px 6px 25px 8px rgba(0, 0, 0, 0.03);
  display: flex;
  align-items: center;
  position: relative;
}
.card img {
  height: 100px;
}
.card-right {
  margin-left: 20px;
}
.card-title {
  font-size: 28px;
  font-weight: 600;
  color: #2f56ce;
}
.card-text {
  font-size: 24px;
  color: #989797;
}

.card .hover {
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.hover-wrap {
  height: 100%;
  background-color: #2f56ce;
  color: #fff;
  font-size: 13px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.hover-wrap p {
  margin: 0;
}

/*  */
.mb .block {
  padding-bottom: 0;
}
.mb .card img {
  height: 80px;
}
.mb .card {
  height: 110px;
}
.mb .card-title {
  font-size: 20px;
}
.mb .card-text {
  font-size: 15px;
}
</style>